module.exports = __webpack_public_path__ + "static/media/bitcoin.5acf0f73.svg";